
export const companyOptions = [
    { value: "Other", label: "Other" },
    { value: "Apple", label: "Apple" },
    { value: "Microsoft", label: "Microsoft" },
    { value: "Amazon", label: "Amazon" },
    { value: "Google", label: "Google" },
    { value: "Facebook (Meta Platforms)", label: "Facebook (Meta Platforms)" },
    { value: "Berkshire Hathaway", label: "Berkshire Hathaway" },
    { value: "Tesla", label: "Tesla" },
    { value: "Tencent", label: "Tencent" },
    { value: "Alibaba", label: "Alibaba" },
    { value: "Samsung Electronics", label: "Samsung Electronics" },
    { value: "Visa", label: "Visa" },
    { value: "Johnson & Johnson", label: "Johnson & Johnson" },
    { value: "JPMorgan Chase", label: "JPMorgan Chase" },
    { value: "Procter & Gamble", label: "Procter & Gamble" },
    { value: "Walmart", label: "Walmart" },
    { value: "Nestlé", label: "Nestlé" },
    { value: "Roche", label: "Roche" },
    { value: "Toyota Motor", label: "Toyota Motor" },
    { value: "Nvidia", label: "Nvidia" },
    { value: "TSMC (Taiwan Semiconductor)", label: "TSMC (Taiwan Semiconductor)" },
    { value: "LVMH (Moët Hennessy Louis Vuitton)", label: "LVMH (Moët Hennessy Louis Vuitton)" },
    { value: "Bank of America", label: "Bank of America" },
    { value: "UnitedHealth Group", label: "UnitedHealth Group" },
    { value: "Pfizer", label: "Pfizer" },
    { value: "Intel", label: "Intel" },
    { value: "Coca-Cola", label: "Coca-Cola" },
    { value: "ExxonMobil", label: "ExxonMobil" },
    { value: "AT&T", label: "AT&T" },
    { value: "PepsiCo", label: "PepsiCo" },
    { value: "Comcast", label: "Comcast" },
    { value: "Cisco Systems", label: "Cisco Systems" },
    { value: "Verizon Communications", label: "Verizon Communications" },
    { value: "Chevron", label: "Chevron" },
    { value: "Nike", label: "Nike" },
    { value: "Adobe", label: "Adobe" },
    { value: "IBM", label: "IBM" },
    { value: "Oracle", label: "Oracle" },
    { value: "SAP", label: "SAP" },
    { value: "Walt Disney", label: "Walt Disney" },
    { value: "Qualcomm", label: "Qualcomm" },
    { value: "McDonald's", label: "McDonald's" },
    { value: "Unilever", label: "Unilever" },
    { value: "Sony", label: "Sony" },
    { value: "Novartis", label: "Novartis" },
    { value: "General Electric", label: "General Electric" },
    { value: "HSBC", label: "HSBC" },
    { value: "Abbott Laboratories", label: "Abbott Laboratories" },
    { value: "Ford Motor", label: "Ford Motor" },
    { value: "Honeywell International", label: "Honeywell International" },
    { value: "Boeing", label: "Boeing" },
    { value: "Accenture", label: "Accenture" },
    { value: "Cognizant", label: "Cognizant" },
    { value: "TCS (Tata Consultancy Services)", label: "TCS (Tata Consultancy Services)" },
    { value: "Infosys", label: "Infosys" },
    { value: "Wipro", label: "Wipro" },
    { value: "HCL Technologies", label: "HCL Technologies" },
    { value: "Tech Mahindra", label: "Tech Mahindra" },
    { value: "Capgemini", label: "Capgemini" },
    { value: "IBM Global Services", label: "IBM Global Services" },
    { value: "DXC Technology", label: "DXC Technology" },
    { value: "L&T Infotech", label: "L&T Infotech" },
    { value: "Mindtree", label: "Mindtree" },
    { value: "NTT Data", label: "NTT Data" },
    { value: "Cimpress", label: "Cimpress" },
    { value: "Cognizant Technology Solutions", label: "Cognizant Technology Solutions" },
    { value: "Oracle Consulting", label: "Oracle Consulting" },
    { value: "SAP Services", label: "SAP Services" },
    { value: "Altran", label: "Altran" },
    { value: "KPMG", label: "KPMG" },
    { value: "Deloitte", label: "Deloitte" },
    { value: "PwC (PricewaterhouseCoopers)", label: "PwC (PricewaterhouseCoopers)" },
    { value: "Ernst & Young (EY)", label: "Ernst & Young (EY)" },
    { value: "Mphasis", label: "Mphasis" },
    { value: "Fujitsu", label: "Fujitsu" },
    { value: "Accenture Song", label: "Accenture Song" },
    { value: "Genpact", label: "Genpact" },
    { value: "Zensar Technologies", label: "Zensar Technologies" },
    { value: "Birlasoft", label: "Birlasoft" },
    { value: "Syntel", label: "Syntel" },
    { value: "Atos", label: "Atos" },
    { value: "Amdocs", label: "Amdocs" },
    { value: "Cognizant Softvision", label: "Cognizant Softvision" },
    { value: "Mediacom", label: "Mediacom" },
    { value: "Aon", label: "Aon" },
    { value: "ManpowerGroup", label: "ManpowerGroup" },
    { value: "Randstad", label: "Randstad" },
    { value: "Robert Half", label: "Robert Half" },
    { value: "Allegis Group", label: "Allegis Group" },
    { value: "Michael Page", label: "Michael Page" },
    { value: "Hays", label: "Hays" },
    { value: "Staffmark", label: "Staffmark" },
    { value: "Kelly Services", label: "Kelly Services" },
    { value: "Adecco", label: "Adecco" },
    { value: "Robert Walters", label: "Robert Walters" },
    { value: "Insight Global", label: "Insight Global" },
    { value: "Celerity", label: "Celerity" },
    { value: "Experis", label: "Experis" },
    { value: "Iconma", label: "Iconma" },
    { value: "Nelson Staffing", label: "Nelson Staffing" },
  ];

 export const domainOptions = [
    { value: "Frontend", label: "Frontend" },
    { value: "Backend", label: "Backend" },
    { value: "Full Stack", label: "Full Stack" },
    { value: "UI/UX", label: "UI/UX" },
    { value: "DevOps / SRE / Cloud", label: "DevOps / SRE / Cloud" },
    { value: "Cyber Security", label: "Cyber Security" },
    { value: "QA / Automation Testing", label: "QA / Automation Testing" },
    { value: "Data Engineer / Big Data", label: "Data Engineer / Big Data" },
    { value: "Data Scientist / AI/ML", label: "Data Scientist / AI/ML" },
    { value: "Data Analyst", label: "Data Analyst" },
    { value: "Sales", label: "Sales" },
    { value: "Marketing", label: "Marketing" },
    {
      value: "Business Analyst / Consultant",
      label: "Business Analyst / Consultant",
    },
    { value: "Finance", label: "Finance" },
    { value: "HR", label: "HR" },
  ];

  export const countryOptions = [{ value: "India", label: "India" }];
  export const stateOptions = [
    { value: "Andhra Pradesh", label: "Andhra Pradesh" },
    { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
    { value: "Assam", label: "Assam" },
    { value: "Bihar", label: "Bihar" },
    { value: "Chhattisgarh", label: "Chhattisgarh" },
    { value: "Goa", label: "Goa" },
    { value: "Gujarat", label: "Gujarat" },
    { value: "Haryana", label: "Haryana" },
    { value: "Himachal Pradesh", label: "Himachal Pradesh" },
    { value: "Jharkhand", label: "Jharkhand" },
    { value: "Karnataka", label: "Karnataka" },
    { value: "Kerala", label: "Kerala" },
    { value: "Madhya Pradesh", label: "Madhya Pradesh" },
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Manipur", label: "Manipur" },
    { value: "Meghalaya", label: "Meghalaya" },
    { value: "Mizoram", label: "Mizoram" },
    { value: "Nagaland", label: "Nagaland" },
    { value: "Odisha", label: "Odisha" },
    { value: "Punjab", label: "Punjab" },
    { value: "Rajasthan", label: "Rajasthan" },
    { value: "Sikkim", label: "Sikkim" },
    { value: "Tamil Nadu", label: "Tamil Nadu" },
    { value: "Telangana", label: "Telangana" },
    { value: "Tripura", label: "Tripura" },
    { value: "Uttarakhand", label: "Uttarakhand" },
    { value: "Uttar Pradesh", label: "Uttar Pradesh" },
    { value: "West Bengal", label: "West Bengal" },
    { value: "Chandigarh", label: "Chandigarh" },
    { value: "Lakshadweep", label: "Lakshadweep" },
    { value: "Delhi", label: "Delhi" },
    { value: "Puducherry", label: "Puducherry" },
    { value: "Ladakh", label: "Ladakh" },
    { value: "Jammu and Kashmir", label: "Jammu and Kashmir" },
  ];
  
  export const languageOptions = [
    { value: "Assamese", label: "Assamese" },
    { value: "Bengali", label: "Bengali" },
    { value: "Bodo", label: "Bodo" },
    { value: "Dogri", label: "Dogri" },
    { value: "Gujarati", label: "Gujarati" },
    { value: "Hindi", label: "Hindi" },
    { value: "Kannada", label: "Kannada" },
    { value: "Kashmiri", label: "Kashmiri" },
    { value: "Konkani", label: "Konkani" },
    { value: "Maithili", label: "Maithili" },
    { value: "Malayalam", label: "Malayalam" },
    { value: "Manipuri", label: "Manipuri" },
    { value: "Marathi", label: "Marathi" },
    { value: "Nepali", label: "Nepali" },
    { value: "Odia", label: "Odia" },
    { value: "Punjabi", label: "Punjabi" },
    { value: "Sanskrit", label: "Sanskrit" },
    { value: "Santali", label: "Santali" },
    { value: "Sindhi", label: "Sindhi" },
    { value: "Tamil", label: "Tamil" },
    { value: "Telugu", label: "Telugu" },
    { value: "Urdu", label: "Urdu" },
    { value: "Tulu", label: "Tulu" },
    { value: "Bhili", label: "Bhili" },
    { value: "Garo", label: "Garo" },
    { value: "Khasi", label: "Khasi" },
    { value: "Mizo", label: "Mizo" },
    { value: "Mundari", label: "Mundari" },
    { value: "Haryanvi", label: "Haryanvi" },
    { value: "Rajasthani", label: "Rajasthani" },
    { value: "Awadhi", label: "Awadhi" },
    { value: "Chhattisgarhi", label: "Chhattisgarhi" },
    { value: "Bhojpuri", label: "Bhojpuri" },
    { value: "Magahi", label: "Magahi" },
    { value: "Marwari", label: "Marwari" },
    { value: "Garhwali", label: "Garhwali" },
    { value: "Kumaoni", label: "Kumaoni" },
    { value: "English", label: "English" },
    { value: "Other", label: "Other" },
];

  export const designationOptions = [
    { value: 'Director', label: 'Director' },
    { value: 'Manager', label: 'Manager' },
    { value: 'Assistant Manager', label: 'Assistant Manager' },
    { value: 'Team Lead', label: 'Team Lead' },
    { value: 'Project Manager', label: 'Project Manager' },
    { value: 'Product Manager', label: 'Product Manager' },
    { value: 'Operations Manager', label: 'Operations Manager' },
    { value: 'Associate', label: 'Associate' },
    { value: 'Analyst', label: 'Analyst' },
    { value: 'Coordinator', label: 'Coordinator' },
    { value: 'Specialist', label: 'Specialist' },
    { value: 'Consultant', label: 'Consultant' },
    { value: 'Executive Assistant', label: 'Executive Assistant' },
    { value: 'Administrative Assistant', label: 'Administrative Assistant' },
    { value: 'Sales Representative', label: 'Sales Representative' },
    { value: 'Customer Service Representative', label: 'Customer Service Representative' },
    { value: 'Software Engineer', label: 'Software Engineer' },
    { value: 'Systems Analyst', label: 'Systems Analyst' },
    { value: 'Database Administrator', label: 'Database Administrator' },
    { value: 'Network Engineer', label: 'Network Engineer' },
    { value: 'Data Scientist', label: 'Data Scientist' },
    { value: 'Web Developer', label: 'Web Developer' },
    { value: 'DevOps Engineer', label: 'DevOps Engineer' },
    { value: 'HR Manager', label: 'HR Manager' },
    { value: 'Recruiter', label: 'Recruiter' },
    { value: 'Training and Development Specialist', label: 'Training and Development Specialist' },
    { value: 'Compensation and Benefits Analyst', label: 'Compensation and Benefits Analyst' },
    { value: 'Marketing Manager', label: 'Marketing Manager' },
    { value: 'Brand Manager', label: 'Brand Manager' },
    { value: 'Sales Manager', label: 'Sales Manager' },
    { value: 'Digital Marketing Specialist', label: 'Digital Marketing Specialist' },
    { value: 'Content Writer', label: 'Content Writer' },
    { value: 'Accountant', label: 'Accountant' },
    { value: 'Financial Analyst', label: 'Financial Analyst' },
    { value: 'Internal Auditor', label: 'Internal Auditor' },
    { value: 'Treasury Analyst', label: 'Treasury Analyst' },
    { value: 'Legal Counsel', label: 'Legal Counsel' },
    { value: 'Compliance Officer', label: 'Compliance Officer' },
    { value: 'Paralegal', label: 'Paralegal' },
    { value: 'CEO', label: 'Chief Executive Officer (CEO)' },
    { value: 'COO', label: 'Chief Operating Officer (COO)' },
    { value: 'CFO', label: 'Chief Financial Officer (CFO)' },
    { value: 'CMO', label: 'Chief Marketing Officer (CMO)' },
    { value: 'CTO', label: 'Chief Technology Officer (CTO)' },
    { value: 'CIO', label: 'Chief Information Officer (CIO)' },
    { value: 'CHRO', label: 'Chief Human Resources Officer (CHRO)' },
    { value: 'CCO', label: 'Chief Compliance Officer (CCO)' },
    { value: 'CSO', label: 'Chief Strategy Officer (CSO)' },
    { value: 'VP', label: 'Vice President (VP)' },
    { value: 'SVP', label: 'Senior Vice President (SVP)' },
    { value: "Other", label: "Other" },
  ];

  export const companyFilterOption = (option, inputValue) => {
    if (option.value === "Other") return true;
    return option.label.toLowerCase().includes(inputValue.toLowerCase());
  };

  export const skillsOptions = [
    // Programming Languages
    { value: 'JavaScript', label: 'JavaScript' },
    { value: 'TypeScript', label: 'TypeScript' },
    { value: 'Python', label: 'Python' },
    { value: 'Java', label: 'Java' },
    { value: 'C++', label: 'C++' },
    { value: 'C#', label: 'C#' },
    { value: 'PHP', label: 'PHP' },
    { value: 'Ruby', label: 'Ruby' },
    { value: 'Go', label: 'Go' },
    { value: 'Rust', label: 'Rust' },
    { value: 'Swift', label: 'Swift' },
    { value: 'Kotlin', label: 'Kotlin' },
    { value: 'Dart', label: 'Dart' },
    { value: 'Scala', label: 'Scala' },
    { value: 'R', label: 'R' },
    { value: 'MATLAB', label: 'MATLAB' },
    { value: 'Perl', label: 'Perl' },
    { value: 'Objective-C', label: 'Objective-C' },
    { value: 'Shell Scripting', label: 'Shell Scripting' },
    { value: 'Bash', label: 'Bash' },
    { value: 'Lua', label: 'Lua' },
    { value: 'Groovy', label: 'Groovy' },
  
    // Web Development
    { value: 'HTML', label: 'HTML' },
    { value: 'CSS', label: 'CSS' },
    { value: 'Sass', label: 'Sass' },
    { value: 'LESS', label: 'LESS' },
    { value: 'React', label: 'React' },
    { value: 'Next.js', label: 'Next.js' },
    { value: 'Redux', label: 'Redux' },
    { value: 'Angular', label: 'Angular' },
    { value: 'Vue.js', label: 'Vue.js' },
    { value: 'Nuxt.js', label: 'Nuxt.js' },
    { value: 'Svelte', label: 'Svelte' },
    { value: 'Gatsby', label: 'Gatsby' },
    { value: 'Bootstrap', label: 'Bootstrap' },
    { value: 'Tailwind CSS', label: 'Tailwind CSS' },
    { value: 'Chakra UI', label: 'Chakra UI' },
    { value: 'Material-UI', label: 'Material-UI' },
    { value: 'Ant Design', label: 'Ant Design' },
    { value: 'Webpack', label: 'Webpack' },
    { value: 'Vite', label: 'Vite' },
    { value: 'Babel', label: 'Babel' },
    { value: 'WebSockets', label: 'WebSockets' },
    { value: 'AJAX', label: 'AJAX' },
  
    // Backend
    { value: 'Node.js', label: 'Node.js' },
    { value: 'Express.js', label: 'Express.js' },
    { value: 'NestJS', label: 'NestJS' },
    { value: 'Django', label: 'Django' },
    { value: 'Flask', label: 'Flask' },
    { value: 'Ruby on Rails', label: 'Ruby on Rails' },
    { value: 'Spring Boot', label: 'Spring Boot' },
    { value: '.NET Core', label: '.NET Core' },
    { value: 'FastAPI', label: 'FastAPI' },
    { value: 'Laravel', label: 'Laravel' },
    { value: 'GraphQL', label: 'GraphQL' },
    { value: 'gRPC', label: 'gRPC' },
    { value: 'REST APIs', label: 'REST APIs' },
    { value: 'API Design', label: 'API Design' },
    { value: 'Microservices', label: 'Microservices' },
    { value: 'Monolithic Architecture', label: 'Monolithic Architecture' },
    { value: 'Serverless', label: 'Serverless' },
  
    // Databases
    { value: 'MongoDB', label: 'MongoDB' },
    { value: 'PostgreSQL', label: 'PostgreSQL' },
    { value: 'MySQL', label: 'MySQL' },
    { value: 'SQLite', label: 'SQLite' },
    { value: 'Redis', label: 'Redis' },
    { value: 'Firebase', label: 'Firebase' },
    { value: 'Oracle Database', label: 'Oracle Database' },
    { value: 'Microsoft SQL Server', label: 'Microsoft SQL Server' },
    { value: 'ElasticSearch', label: 'ElasticSearch' },
    { value: 'DynamoDB', label: 'DynamoDB' },
    { value: 'Cassandra', label: 'Cassandra' },
    { value: 'MariaDB', label: 'MariaDB' },
    { value: 'Memcached', label: 'Memcached' },
    { value: 'Neo4j', label: 'Neo4j' },
    { value: 'CouchDB', label: 'CouchDB' },
    { value: 'Firestore', label: 'Firestore' },
    { value: 'GraphQL Database', label: 'GraphQL Database' },
    { value: 'Database Design', label: 'Database Design' },
    { value: 'SQL Optimization', label: 'SQL Optimization' },
    { value: 'Indexing', label: 'Indexing' },
  
    // DevOps & Cloud
    { value: 'Docker', label: 'Docker' },
    { value: 'Kubernetes', label: 'Kubernetes' },
    { value: 'AWS', label: 'Amazon Web Services (AWS)' },
    { value: 'AWS EC2', label: 'AWS EC2' },
    { value: 'AWS S3', label: 'AWS S3' },
    { value: 'AWS Lambda', label: 'AWS Lambda' },
    { value: 'AWS RDS', label: 'AWS RDS' },
    { value: 'Azure', label: 'Microsoft Azure' },
    { value: 'Azure App Service', label: 'Azure App Service' },
    { value: 'Azure Functions', label: 'Azure Functions' },
    { value: 'Google Cloud', label: 'Google Cloud Platform' },
    { value: 'Terraform', label: 'Terraform' },
    { value: 'Ansible', label: 'Ansible' },
    { value: 'Jenkins', label: 'Jenkins' },
    { value: 'GitLab CI/CD', label: 'GitLab CI/CD' },
    { value: 'GitHub Actions', label: 'GitHub Actions' },
    { value: 'CircleCI', label: 'CircleCI' },
    { value: 'Prometheus', label: 'Prometheus' },
    { value: 'Grafana', label: 'Grafana' },
    { value: 'Vercel', label: 'Vercel' },
    { value: 'Netlify', label: 'Netlify' },
    { value: 'Heroku', label: 'Heroku' },
    { value: 'Infrastructure as Code', label: 'Infrastructure as Code' },
    { value: 'Continuous Integration', label: 'Continuous Integration' },
    { value: 'Continuous Deployment', label: 'Continuous Deployment' },
    { value: 'Splunk', label: 'Splunk' },
    { value: 'Datadog', label: 'Datadog' },
    { value: 'New Relic', label: 'New Relic' },
    { value: 'Service Mesh', label: 'Service Mesh' },
    { value: 'Istio', label: 'Istio' },
  
    // Mobile
    { value: 'React Native', label: 'React Native' },
    { value: 'Flutter', label: 'Flutter' },
    { value: 'SwiftUI', label: 'SwiftUI' },
    { value: 'Xamarin', label: 'Xamarin' },
    { value: 'Android Development', label: 'Android Development' },
    { value: 'iOS Development', label: 'iOS Development' },
  
    // Machine Learning & Data
    { value: 'TensorFlow', label: 'TensorFlow' },
    { value: 'PyTorch', label: 'PyTorch' },
    { value: 'Scikit-learn', label: 'Scikit-learn' },
    { value: 'Pandas', label: 'Pandas' },
    { value: 'NumPy', label: 'NumPy' },
    { value: 'Keras', label: 'Keras' },
    { value: 'OpenCV', label: 'OpenCV' },
    { value: 'Apache Spark', label: 'Apache Spark' },
    { value: 'Power BI', label: 'Power BI' },
    { value: 'Tableau', label: 'Tableau' },
    { value: 'Natural Language Processing', label: 'Natural Language Processing (NLP)' },
    { value: 'Computer Vision', label: 'Computer Vision' },
    { value: 'Deep Learning', label: 'Deep Learning' },
    { value: 'Statistical Analysis', label: 'Statistical Analysis' },
    { value: 'Data Visualization', label: 'Data Visualization' },
    { value: 'Apache Airflow', label: 'Apache Airflow' },
    { value: 'ETL', label: 'ETL (Extract, Transform, Load)' },
    { value: 'Data Pipeline', label: 'Data Pipeline' },
    { value: 'MLOps', label: 'Machine Learning Operations (MLOps)' },
  
    // Message Queues & Event Streaming
    { value: 'Apache Kafka', label: 'Apache Kafka' },
    { value: 'RabbitMQ', label: 'RabbitMQ' },
    { value: 'AWS SQS', label: 'AWS SQS' },
    { value: 'AWS SNS', label: 'AWS SNS' },
    { value: 'Azure Service Bus', label: 'Azure Service Bus' },
    { value: 'Event Streaming', label: 'Event Streaming' },
    { value: 'Stream Processing', label: 'Stream Processing' },
    { value: 'Apache Flink', label: 'Apache Flink' },
  
    // Cybersecurity
    { value: 'Ethical Hacking', label: 'Ethical Hacking' },
    { value: 'Penetration Testing', label: 'Penetration Testing' },
    { value: 'OWASP', label: 'OWASP' },
    { value: 'Network Security', label: 'Network Security' },
    { value: 'Application Security', label: 'Application Security' },
    { value: 'OAuth/JWT', label: 'OAuth/JWT' },
    { value: 'OAuth 2.0', label: 'OAuth 2.0' },
    { value: 'API Security', label: 'API Security' },
    { value: 'SSL/TLS', label: 'SSL/TLS' },
    { value: 'Encryption', label: 'Encryption' },
    { value: 'Authentication', label: 'Authentication' },
    { value: 'Authorization', label: 'Authorization' },
    { value: 'SSO/SAML', label: 'Single Sign-On (SSO/SAML)' },
  
    // Testing
    { value: 'Selenium', label: 'Selenium' },
    { value: 'Cypress', label: 'Cypress' },
    { value: 'Jest', label: 'Jest' },
    { value: 'Mocha', label: 'Mocha' },
    { value: 'Chai', label: 'Chai' },
    { value: 'JUnit', label: 'JUnit' },
    { value: 'Postman', label: 'Postman' },
    { value: 'Unit Testing', label: 'Unit Testing' },
    { value: 'Integration Testing', label: 'Integration Testing' },
    { value: 'End-to-End Testing', label: 'End-to-End Testing' },
    { value: 'Load Testing', label: 'Load Testing' },
    { value: 'Performance Testing', label: 'Performance Testing' },
    { value: 'Security Testing', label: 'Security Testing' },
    { value: 'Behavior-Driven Development', label: 'Behavior-Driven Development (BDD)' },
    { value: 'Test-Driven Development', label: 'Test-Driven Development (TDD)' },
  
    // Architecture & Patterns
    { value: 'Event-Driven Architecture', label: 'Event-Driven Architecture' },
    { value: 'Domain-Driven Design', label: 'Domain-Driven Design (DDD)' },
    { value: 'CQRS', label: 'CQRS (Command Query Responsibility Segregation)' },
    { value: 'Event Sourcing', label: 'Event Sourcing' },
    { value: 'Service-Oriented Architecture', label: 'Service-Oriented Architecture (SOA)' },
    { value: 'MVC', label: 'MVC Architecture' },
    { value: 'MVVM', label: 'MVVM Architecture' },
    { value: 'MVP', label: 'MVP Architecture' },
    { value: 'Clean Architecture', label: 'Clean Architecture' },
    { value: 'Hexagonal Architecture', label: 'Hexagonal Architecture' },
    { value: 'Design Patterns', label: 'Design Patterns' },
    { value: 'Singleton Pattern', label: 'Singleton Pattern' },
    { value: 'Factory Pattern', label: 'Factory Pattern' },
    { value: 'Builder Pattern', label: 'Builder Pattern' },
    { value: 'Observer Pattern', label: 'Observer Pattern' },
    { value: 'Strategy Pattern', label: 'Strategy Pattern' },
    { value: 'Decorator Pattern', label: 'Decorator Pattern' },
    { value: 'Proxy Pattern', label: 'Proxy Pattern' },
    { value: 'Repository Pattern', label: 'Repository Pattern' },
    { value: 'Dependency Injection', label: 'Dependency Injection' },
    { value: 'Circuit Breaker', label: 'Circuit Breaker Pattern' },
    { value: 'Bulkhead Pattern', label: 'Bulkhead Pattern' },
    { value: 'SOLID Principles', label: 'SOLID Principles' },
    { value: 'Object-Oriented Programming', label: 'Object-Oriented Programming (OOP)' },
    { value: 'Functional Programming', label: 'Functional Programming' },
    { value: 'Reactive Programming', label: 'Reactive Programming' },
  
    // Data Structures & Algorithms
    { value: 'Data Structures', label: 'Data Structures' },
    { value: 'Algorithms', label: 'Algorithms' },
    { value: 'Problem Solving', label: 'Competitive Programming' },
  
    // Version Control & Collaboration
    { value: 'Git', label: 'Git' },
    { value: 'GitHub', label: 'GitHub' },
    { value: 'GitLab', label: 'GitLab' },
    { value: 'Bitbucket', label: 'Bitbucket' },
    { value: 'Jira', label: 'Jira' },
    { value: 'Confluence', label: 'Confluence' },
    { value: 'Code Review', label: 'Code Review' },
  
    // Design & UI/UX
    { value: 'Figma', label: 'Figma' },
    { value: 'Adobe XD', label: 'Adobe XD' },
    { value: 'Adobe Photoshop', label: 'Adobe Photoshop' },
    { value: 'Adobe Illustrator', label: 'Adobe Illustrator' },
    { value: 'UI/UX Design', label: 'UI/UX Design' },
    { value: 'User Experience', label: 'User Experience (UX)' },
    { value: 'User Interface', label: 'User Interface (UI)' },
    { value: 'Wireframing', label: 'Wireframing' },
    { value: 'Prototyping', label: 'Prototyping' },
  
    // Soft Skills
    { value: 'Problem Solving', label: 'Problem Solving' },
    { value: 'Critical Thinking', label: 'Critical Thinking' },
    { value: 'Communication', label: 'Communication' },
    { value: 'Teamwork', label: 'Teamwork' },
    { value: 'Time Management', label: 'Time Management' },
    { value: 'Creativity', label: 'Creativity' },
    { value: 'Leadership', label: 'Leadership' },
    { value: 'Adaptability', label: 'Adaptability' },
    { value: 'Mentoring', label: 'Mentoring' },
    { value: 'Stakeholder Management', label: 'Stakeholder Management' },
  
    // Agile & Management
    { value: 'Agile', label: 'Agile Methodology' },
    { value: 'Scrum', label: 'Scrum' },
    { value: 'Kanban', label: 'Kanban' },
    { value: 'Lean', label: 'Lean' },
    { value: 'Project Management', label: 'Project Management' },
    { value: 'Product Management', label: 'Product Management' },
    { value: 'Release Management', label: 'Release Management' },
  
    // Emerging Tech
    { value: 'Blockchain', label: 'Blockchain' },
    { value: 'Smart Contracts', label: 'Smart Contracts' },
    { value: 'Solidity', label: 'Solidity' },
    { value: 'Web3', label: 'Web3 Development' },
    { value: 'IoT', label: 'Internet of Things (IoT)' },
    { value: 'AR/VR', label: 'Augmented/Virtual Reality' },
    { value: '3D Modeling', label: '3D Modeling' },
    { value: 'Game Development', label: 'Game Development' },
    { value: 'Unity', label: 'Unity' },
    { value: 'Unreal Engine', label: 'Unreal Engine' },
    { value: 'Blender', label: 'Blender' },
  
    // Marketing & Content
    { value: 'SEO', label: 'Search Engine Optimization (SEO)' },
    { value: 'Digital Marketing', label: 'Digital Marketing' },
    { value: 'Content Writing', label: 'Content Writing' },
    { value: 'Technical Writing', label: 'Technical Writing' },
    { value: 'API Documentation', label: 'API Documentation' },
  ];
  
  

  export const degreeOptions = [
    { value: 'B.Tech', label: 'B.Tech' },
    { value: 'B.E.', label: 'B.E.' },
    { value: 'B.Sc.', label: 'B.Sc.' },
    { value: 'B.A.', label: 'B.A.' },
    { value: 'B.Ed.', label: 'B.Ed.' },
    { value: 'B.Com', label: 'B.Com' },
    { value: 'BBA', label: 'BBA' },
    { value: 'BCA', label: 'BCA' },
    { value: 'BHM', label: 'BHM' },
    { value: 'B. Pharmacy', label: 'B. Pharmacy' },
    { value: 'M.Tech', label: 'M.Tech' },
    { value: 'M.E.', label: 'M.E.' },
    { value: 'M.Sc.', label: 'M.Sc.' },
    { value: 'M.A.', label: 'M.A.' },
    { value: 'M.Ed.', label: 'M.Ed.' },
    { value: 'M.Com', label: 'M.Com' },
    { value: 'MBA', label: 'MBA' },
    { value: 'MCA', label: 'MCA' },
    { value: 'M. Pharmacy', label: 'M. Pharmacy' },
    { value: 'MSW', label: 'MSW' },
    { value: 'Ph.D.', label: 'Ph.D.' },
    { value: 'Ed.D.', label: 'Ed.D.' },
    { value: 'D. Pharmacy', label: 'D. Pharmacy' },
    { value: 'D.Ed.', label: 'D.Ed.' },
    { value: 'PGDM', label: 'PGDM' },
    { value: 'PGDE', label: 'PGDE' },
  ];